import { useEffect } from "react"

const D = {
  title: "r4v3n",
  description:
    "r4v3n — generative artist. On-chain generative art and 1/1 works fusing algorithms with human emotion: Dots, Marfa, Moments, Pieces of Me, Color Streams.",
  ogTitle: "r4v3n — generative artist",
  ogDescription: "On-chain generative art and 1/1 works fusing algorithms with human emotion.",
  ogImage: "https://r4v3n.art/og-image.png",
  ogUrl: "https://r4v3n.art/",
}

function set(sel: string, attr: string, val: string) {
  document.querySelector(sel)?.setAttribute(attr, val)
}

const usePageMeta = (
  title?: string,
  description?: string,
  ogImage?: string,
  path?: string,
) => {
  useEffect(() => {
    if (!title) return

    const ogUrl = path ? `https://r4v3n.art${path}` : D.ogUrl
    const desc = description || D.ogDescription

    document.title = title
    set('meta[name="description"]', "content", description || D.description)
    set('link[rel="canonical"]', "href", ogUrl)
    set('meta[property="og:title"]', "content", title)
    set('meta[property="og:description"]', "content", desc)
    set('meta[property="og:image"]', "content", ogImage || D.ogImage)
    set('meta[property="og:url"]', "content", ogUrl)
    set('meta[name="twitter:title"]', "content", title)
    set('meta[name="twitter:description"]', "content", desc)
    set('meta[name="twitter:image"]', "content", ogImage || D.ogImage)

    return () => {
      document.title = D.title
      set('meta[name="description"]', "content", D.description)
      set('link[rel="canonical"]', "href", D.ogUrl)
      set('meta[property="og:title"]', "content", D.ogTitle)
      set('meta[property="og:description"]', "content", D.ogDescription)
      set('meta[property="og:image"]', "content", D.ogImage)
      set('meta[property="og:url"]', "content", D.ogUrl)
      set('meta[name="twitter:title"]', "content", D.ogTitle)
      set('meta[name="twitter:description"]', "content", D.ogDescription)
      set('meta[name="twitter:image"]', "content", D.ogImage)
    }
  }, [title, description, ogImage, path])
}

export default usePageMeta
